import React from 'react';

import { useState, useCallback } from 'react';

export type RadioButtonState = string;
export type SetRadioButtonState = (value: RadioButtonState) => void;
export type ChangeRadioButtonState = React.MouseEventHandler<HTMLButtonElement>;

export const useRadioButtonState = (initValue: RadioButtonState) => {
  const [value, setValue] = useState<RadioButtonState>(() => (initValue || ''));

  const changeValue = useCallback(({ target: { value = '' } }: any) => {
    setValue(prevValue => prevValue === value ? '' : value);
  }, [setValue]);

  return [value, changeValue, setValue] as const;
};

